<template>
  <b-table striped borderless responsive class="vud-numbers-table position-relative" :busy="loading"
    :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" sort-icon-left sticky-header no-border-collapse
    :items="mappedItems" show-empty :empty-text="$t('errors.emptyTable.title')"
    :empty-filtered-text="$t('errors.emptyTable.title')" :fields="fields">
    <template #table-busy>
      <div class="text-center text-primary my-2">
        <b-spinner class="align-middle mr-2" />
        <strong>{{ $t("Carregant") }}...</strong>
      </div>
    </template>

    <!-- Column: name -->
    <template #cell(name)="data">
      <b-accommodation :uuid="data.item.uuid" :name="data.item.name" />
    </template>

    <!-- Column: ventanillaUnicaLicenceNumber -->
    <template #cell(ventanillaUnicaLicenceNumber)="data">
      <b-badge v-if="!data.value" variant="danger">
        {{ $t("No definit") }}
      </b-badge>
      <span v-else>
        {{ data.value }}
      </span>
    </template>

    <!-- Column: ventanillaUnicaLicenceNumberValid -->
    <template #cell(ventanillaUnicaLicenceNumberValid)="data">
      <b-badge v-if="data.value === true" variant="success">
        {{ $t("Vàlid") }}
      </b-badge>
      <b-badge v-else-if="data.value === false" variant="danger"
        @click="validateVUDNumber(data.item.ventanillaUnicaLicenceNumber)">
        {{ $t("No vàlid") }}
      </b-badge>
      <b-badge v-else variant="secondary" class="cursor-pointer"
        @click="validateVUDNumber(data.item.ventanillaUnicaLicenceNumber)">
        {{ $t("Pendent de validar") }}
      </b-badge>
    </template>

    <!-- Column: ventanillaUnicaLicenceNumberValidatedAt -->
    <template #cell(ventanillaUnicaLicenceNumberValidatedAt)="data">
      <span v-if="data.value">
        {{ formatValidationDate(data.value) }}
      </span>
      <b-badge v-else variant="secondary">
        {{ $t("No definit") }}
      </b-badge>
    </template>
  </b-table>
</template>

<script>
import { BTable, BSpinner, BBadge } from "bootstrap-vue";
import BAccommodation from "@foravila-core/components/b-accommodation/BAccommodation.vue";
import { formatDateStringToDate } from "@/utils/formatters";
import { notifyError, notifySuccess } from "@/utils/methods";

export default {
  components: {
    BTable,
    BSpinner,
    BAccommodation,
    BBadge,
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    items: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  data() {
    return {
      sortBy: "name",
      sortDesc: false,
      fields: [
        { key: "name", label: this.$t("Allotjament"), sortable: true },
        { key: "ventanillaUnicaLicenceNumber", label: "VUD", sortable: true },
        { key: "ventanillaUnicaLicenceNumberValid", label: this.$t("Vàlid?"), sortable: true },
        { key: "ventanillaUnicaLicenceNumberValidatedAt", label: this.$t("Data de validació"), sortable: true },
      ],
      formatDateStringToDate
    };
  },
  computed: {
    mappedItems() {
      if (!this.items.length) return [];
      return this.items.map((accommodation) => ({
        uuid: accommodation.uuid || this.$t("No definit"),
        name: accommodation.name || this.$t("No definit"),
        ventanillaUnicaLicenceNumber: accommodation.ventanillaUnicaLicenceNumber || null,
        ventanillaUnicaLicenceNumberValid: accommodation.ventanillaUnicaLicenceNumberValid,
        ventanillaUnicaLicenceNumberValidatedAt: accommodation.ventanillaUnicaLicenceNumberValidatedAt || null,
      }));
    },
  },
  methods: {
    formatValidationDate(dateString) {
      if (!dateString) return this.$t("No definit");
      const formatting = { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' };
      return this.formatDateStringToDate(dateString, "ca-ES", formatting);
    },
    validateVUDNumber(ventanillaUnicaLicenceNumber) {
      if (!ventanillaUnicaLicenceNumber) {
        notifyError(
          "Número de VUD no vàlid",
          "Si us plau, introdueix un número de VUD per validar"
        );
        return;
      }

      this.$store.dispatch("app/setLoading", true);

      this.$store
        .dispatch("accommodation/validateVUDNumber", {
          ventanillaUnicaLicenceNumber
        })
        .then((response) => {
          const isValid = response.isValid;

          if (!isValid) {
            notifyError(
              "VUD no vàlid",
              "El número de Ventanilla Única Digital no és vàlid, si us plau, revisa les dades introduïdes"
            )
            return;
          }

          notifySuccess(
            "VUD validat",
            "El número de Ventanilla Única Digital s'ha validat correctament"
          )
        })
        .catch((error) => {
          let message =
            "El número de Ventanilla Única Digital no s'ha pogut validar correctament, si us plau, revisa les dades introduïdes";
          if (error?.response?.data?.message) {
            message = error.response.data.message;
          }
          notifyError("VUD no vàlid", message);
        })
        .finally(() => {
          this.$emit("vud-validated", ventanillaUnicaLicenceNumber);
          this.$store.dispatch("app/setLoading", false);
        });
    },
  },
};
</script>

<style lang="scss">
.vud-numbers-table {
  max-height: 800px !important;
}
</style>
